import { useEffect, useState } from "react";
import Select from "react-select";
import { fetchApproversApiHandler } from "../../../services/api/apiHandler";
import Dropdown from "../../elements/Dropdown";
import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const ApproverLeaseModal = ({setApproverLeaseModal, companyId,setApproverId,sendForApproval}) => {
  const [approvers, setApprovers] = useState([]);
  const [selectedApproverId, setSelectedApproverId] = useState(null); // store _id

  useEffect(() => {
    fetchApprovers();
  }, []);

  const fetchApprovers = () => {
    fetchApproversApiHandler({ companyID: companyId })
      .then((response) => {
        setApprovers(response?.data.approvers);
      })
      .catch((error) => {
        alert(error.response.data.error);
      });
  };

  // Build react-select options from your data: {_id, name}
  const approverOptions = approvers.map((approver) => ({
    value: approver._id,
    label: approver.name,
  }));

  // Current value for react-select
  const selectedOption =
    approverOptions.find((opt) => opt.value === selectedApproverId) || null;

  // If you still need the full approver object:
  const selectedApprover =
    approvers.find((a) => a._id === selectedApproverId) || null;

  function completeStep() {
    // Example with your original logic:
    // modification["approverID"] = selectedApproverId; // or selectedApprover?._id
    // modification["approvalStatus"] = "pending approval";
    // ...
  }

  return (
    <Modal
      title="Select Approver"
      headerActions={
        <CloseIcon
          onClick={() => {
            setApproverLeaseModal(false);
          }}
          className="clickable"
        />
      }
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setApproverLeaseModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Send"
            onClick={()=>{selectedApproverId && (sendForApproval(selectedApproverId.value))}}
          />
        </>
      }
      onClose={() => console.log("Modal Closed")}
    >
      <Dropdown
        label="Select Approver"
        options={approverOptions}
        onSelect={(value) => {setApproverId(value);setSelectedApproverId(value)}}
        placeHolder={"Select Approver"}
        // selected={{ label: "OAuth", value: "OAuth" }}
      />
    </Modal>
  );
};

export default ApproverLeaseModal;
